import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { Dropdown } from '../containers';
import {
  dropdownPosition,
  navAvatarHoverColor,
  navDropdownStyles,
  navItemHoverBgColor,
} from './theme-nav';
import NavAvatar from './NavAvatar';

export const AvatarDropdown = styled(Dropdown)`
  ${dropdownPosition.left};
  ${navDropdownStyles};
  &:hover {
    background: ${navItemHoverBgColor};
    i {
      background: ${navAvatarHoverColor};
    }
  }
  @media screen and (max-width: 1000px) {
    order: ${(props) => props.mobileorder};
    &:hover {
      background: none;
    }
  }

  margin-top: unset;
`;

const NavLinksUser = ({ links, avatarUrl, mobileorder }) => {
  const trigger = () => <NavAvatar size="small" src={avatarUrl} />;
  return <AvatarDropdown Trigger={trigger} links={links} mobileorder={mobileorder} />;
};

const dropdownLinkShape = PropTypes.shape({
  name: PropTypes.string,
  path: PropTypes.string,
});

NavLinksUser.defaultProps = {
  mobileorder: '',
};

NavLinksUser.propTypes = {
  mobileorder: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.oneOfType([dropdownLinkShape, PropTypes.arrayOf(dropdownLinkShape)])
  ).isRequired,
  avatarUrl: PropTypes.string,
};

NavLinksUser.defaultProps = {
  avatarUrl: undefined,
};

export default NavLinksUser;
